import React from 'react';
import styled from 'styled-components';
const AboutSection = styled.section`
  padding: 100px 10%;
  background-color: var(--color-bg-alt);

  @media (max-width: 768px) {
    padding: 80px 5%;
  }
  
  @media (max-width: 576px) {
    padding: 60px 5%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--color-text);
  margin-bottom: 1.5rem;
  text-align: center;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 70px;
    height: 4px;
    background-color: var(--color-primary);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 950px;
  margin: 0 auto;
`;

const AboutContent = styled.div`
  text-align: center;
`;

const AboutText = styled.div`
  margin-bottom: 2rem;

  p {
    font-size: 1.0rem;
    color: var(--color-secondary);
    line-height: 1.8;
    margin-bottom: 1.5rem;
  }
    @media (max-width: 768px) {
    p {
      font-size: 0.9rem; /* Even smaller on mobile */
    }
  }
  
  @media (max-width: 576px) {
    p {
      font-size: 0.85rem; /* Smallest on very small screens */
}}
`;

const AboutDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

const DetailItem = styled.div`
  display: flex;
  align-items: center;

  .icon {
    margin-right: 10px;
    color: var(--color-primary);
    font-size: 1.2rem;
    
    @media (max-width: 768px) {
      font-size: 1rem;
    }
    
    @media (max-width: 576px) {
      font-size: 0.9rem;
    }
  }

  p {
    font-size: 1rem;
    color: var(--color-secondary);

    strong {
      color: var(--color-text);
      font-weight: 600;
    }
    
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
    
    @media (max-width: 576px) {
      font-size: 0.8rem;
    }
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <SectionTitle>Highlights</SectionTitle>
        <ContentContainer>
        <AboutContent>
          <AboutText>
            <p>
            With over two decades of industry leadership, I bring a proven track record in product innovation, wireless systems design, and large-scale technology execution. My strategic roles at Google, Apple, Amazon, and Samsung involved leading cross-functional teams, launching flagship products, and shaping next-generation technologies that impact billions globally. As a visionary CEO with over 30+ patents, I leverage my engineering foundation and passion for purposeful technology to transform disruptive ideas into significant business value at PanSas, empowering people and reshaping industries.
            </p>
          </AboutText>
          
          <AboutDetails>
            <DetailItem>
              <div className="icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <p><strong>Location:</strong> Mountain View, California, USA</p>
            </DetailItem>
            <DetailItem>
              <div className="icon">
                <i className="fas fa-building"></i>
              </div>
              <p><strong>Current Role:</strong> Founder & CEO - Stealth AGI Startup</p>
            </DetailItem>
            <DetailItem>
              <div className="icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <p><strong>Alma Mater:</strong> Anna University, India</p>
            </DetailItem>
            <DetailItem>
              <div className="icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <p><strong>Patents:</strong> Filed: 30+ | Granted: 2</p>
            </DetailItem>
          </AboutDetails>
        </AboutContent>
      </ContentContainer>
    </AboutSection>
  );
};

export default About;